export default {"src":"/_next/static/media/trash-white.ebd7eadb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};